import { appInfo } from '@/mocks/home';

export default function AppSection() {
  return (
    <section id="app" className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-900">移动端观影</h2>
        </div>

        <div className="bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40 rounded-2xl border border-background-200/70 overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center gap-6 md:gap-10 p-6 md:p-10">
            <div className="flex-shrink-0">
              <div className="w-40 h-40 md:w-48 md:h-48 bg-background-50 rounded-2xl flex items-center justify-center border border-background-200/70">
                <div className="text-center">
                  <div className="w-16 h-16 md:w-20 md:h-20 mx-auto flex items-center justify-center rounded-2xl bg-primary-500 text-background-50">
                    <i className="ri-smartphone-line text-3xl md:text-4xl"></i>
                  </div>
                  <p className="text-sm text-foreground-400 mt-3">扫码下载APP</p>
                </div>
              </div>
            </div>

            <div className="flex-1 text-center lg:text-left">
              <h3 className="text-lg md:text-xl font-bold text-foreground-900 mb-3">
                {appInfo.title}
              </h3>
              <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-5">
                {appInfo.description}
              </p>
              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-2 md:gap-3">
                {appInfo.platforms.map((platform) => (
                  <span key={platform} className="px-4 py-2 bg-background-50 border border-background-200/70 rounded-full text-sm font-medium text-foreground-600 whitespace-nowrap">
                    <i className="ri-apple-line mr-1.5 text-primary-500"></i>
                    {platform}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}